export default __webpack_public_path__ + "static/media/telegram.59e4230d.png";